// extracted by mini-css-extract-plugin
export var attachment = "_pz-a";
export var emailContainer = "_pz-4";
export var emailContentPaddedContainer = "_pz-b";
export var emailHeader = "_pz-6";
export var emailIframe = "_pz-3";
export var emailInfoIcon = "_pz-9";
export var emailShortenedSummary = "_pz-e";
export var infoDropdown = "_pz-0";
export var infoRowBoundedContent = "_pz-d";
export var internal = "_pz-5";
export var merchant = "_pz-8";
export var messageInputContainer = "_pz-h";
export var normal = "_pz-7";
export var replyCard = "_pz-f";
export var subtleButton = "_pz-1";
export var subtleButtonIconContainer = "_pz-2";
export var toggleViewRepliesButton = "_pz-c";
export var wrappingText = "_pz-g";